var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMobileNavPlayerReport = function SvgIcnMobileNavPlayerReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7998 8.8126V17.1001C18.7998 19.6501 17.2783 20.5001 15.3998 20.5001H8.59983C6.72133 20.5001 5.19983 19.6501 5.19983 17.1001V8.8126C5.19983 6.0501 6.72133 5.4126 8.59983 5.4126C8.59983 5.9396 8.81231 6.41559 9.16081 6.76409C9.50931 7.11259 9.98533 7.3251 10.5123 7.3251H13.4873C14.5413 7.3251 15.3998 6.4666 15.3998 5.4126C17.2783 5.4126 18.7998 6.0501 18.7998 8.8126Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4003 5.41262C15.4003 6.46662 14.5418 7.32512 13.4878 7.32512H10.5128C9.98584 7.32512 9.50982 7.11262 9.16132 6.76412C8.81282 6.41562 8.60034 5.93962 8.60034 5.41262C8.60034 4.35862 9.45884 3.50012 10.5128 3.50012H13.4878C14.0148 3.50012 14.4909 3.71263 14.8394 4.06113C15.1879 4.40963 15.4003 4.88562 15.4003 5.41262Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 12.85H12.0003",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 16.2501H15.4003",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMobileNavPlayerReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_mobile_nav_player_report.0fd83da7.svg";
export { ForwardRef as ReactComponent };